var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitbarg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 546 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bitbarg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: "-4.5%",
    y: "-13.1%",
    width: "109%",
    height: "126.1%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 17)",
    fillRule: "nonzero",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m-5.8248e-4 0h34.829c9.534 0 15.955 0.5765 22.181 2.8825 12.647 4.612 22.376 14.989 22.376 31.131 0 11.146-5.059 21.33-20.236 27.672 19.458 3.6512 31.716 16.911 31.716 33.629 0 21.33-17.901 30.362-25.878 33.053-7.7831 2.6904-14.009 2.6904-28.214 2.6904h-36.775v-131.06zm31.522 16.718h-12.647v39.395h12.647c4.8644 0 13.231-0.38433 17.901-3.0747 3.6969-1.9217 10.312-7.1103 10.312-17.487 0-7.3026-3.5023-13.644-9.3395-16.334-5.4481-2.4982-13.231-2.4982-18.874-2.4982h5.825e-4zm5.2536 56.305h-17.901v41.316h18.874c5.4481 0 14.788 0 19.652-1.9217 9.7286-3.6512 13.815-11.915 13.815-18.832 0-5.5728-2.7241-13.836-12.647-17.872-5.059-2.1138-11.48-2.6904-21.792-2.6904h-5.825e-4z",
    fill: "#4285F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m109.41 8.7372c5.9914 0 10.584 4.6233 10.584 10.017s-4.793 10.21-10.584 10.21c-6.79 0-10.385-5.9716-10.385-10.21 0-4.8159 4.3936-10.017 10.385-10.017zm8.9871 36.409v86.492h-17.774v-86.492h17.774z",
    fill: "#EB4137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m160.08 25.046v17.894h27.155v15.392h-27.155v37.71c0.19123 10.774 0.38247 12.698 3.0598 15.776 3.251 3.4632 7.4581 3.6556 9.1793 3.6556 3.4422 0 9.9441-0.3848 19.315-6.1568v15.969c-8.0318 4.4252-17.02 5.772-21.992 5.772-5.9285 0-16.446-2.5012-22.375-10.967-4.2072-6.349-4.2072-15.584-4.2072-23.473v-38.287h-14.916v-1.7316l31.936-31.554h-5.9e-5z",
    fill: "#FBBD06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m217.03 0v50.188c2.9052-2.0833 11.04-7.765 24.017-7.765 23.242 0 37.381 19.507 37.381 43.37 0 29.924-21.111 45.265-44.934 45.265-11.04 0-25.372-2.6514-33.701-6.6286v-124.43h17.238-5.83e-4zm0 66.286v46.022c6.9723 2.0833 15.301 2.6514 18.206 2.6514 10.265 0 25.76-7.1965 25.76-28.409 0-19.129-12.008-28.598-24.404-28.598-9.6843 0-16.076 5.3029-19.562 8.333l5.82e-4 5.825e-4z",
    fill: "#4285F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m361.14 116.07v10.507c-7.9403 5.2536-11.232 6.8104-16.655 6.8104-7.5524 0-11.619-2.7241-13.169-8.9504-7.5524 6.0316-15.492 8.9504-23.433 8.9504-12.781 0-21.302-10.118-21.302-21.403 0-17.317 15.686-22.571 29.63-27.63l15.299-5.4481v-4.6698c0-10.896-5.2287-15.372-15.686-15.372-9.4892 0-19.172 4.4753-27.499 14.398v-18.874c6.7777-7.9776 16.267-11.869 28.855-11.869 17.623 0 31.566 8.9504 31.566 28.797v44.947c0 3.3078 1.1619 4.4753 3.2921 4.4753 1.7429 0 5.2287-1.7512 9.1018-4.6698v2.33e-4zm-29.63-2.1403v-25.489c-14.718 5.059-27.499 10.118-27.499 20.43 0 7.1995 5.2287 12.258 12.394 12.258 5.4224 0 10.457-2.7241 15.105-7.1995z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.29 46.591h16.595v19.911c5.4075-8.6988 13.239-21.651 24.986-21.651 2.424 0 9.8824 0.19331 19.579 9.8591l-8.764 15.078c-2.0511-2.1265-9.5096-8.506-16.036-8.506-6.1533 0-19.765 6.9595-19.765 26.677v45.428h-16.595v-86.795-0.001165z",
    fill: "#EB4237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.42 44.851v13.319h-17.693c6.7311 6.7556 9.0389 11.581 9.0389 18.915 0 7.1418-4.0386 15.442-8.0773 19.494-11.539 12.353-35.001 6.1766-35.001 16.406 0 4.8254 9.0389 7.7208 26.347 11.195 18.462 3.6673 25.001 13.125 25.001 24.127 0 17.179-15.193 27.601-40.771 27.601-23.27 0-39.809-11.002-39.809-26.25 0-12.739 6.7311-20.267 21.732-23.934-5.9617-3.6673-8.6539-7.1418-8.6539-11.002 0-5.5975 5.3849-10.423 13.654-12.353v-0.38603c-6.3461-2.7022-11.154-6.3694-14.423-11.002-3.0771-4.4394-4.6156-9.8439-4.6156-16.213 0-18.529 14.423-29.917 37.694-29.917h35.578-0.00233zm-24.04 30.111c0-8.2998-7.6928-15.248-16.731-15.248-9.4234 0-17.116 7.1418-17.116 15.634 0 9.4577 6.9234 15.827 17.308 15.827 9.6156 0 16.539-6.7556 16.539-16.213zm7.1156 74.697c0-11.002-17.693-13.897-28.27-13.897-11.539 0-19.616 5.4045-19.616 13.125 0 8.6859 8.4617 13.318 24.04 13.318 15.001 0 23.847-4.6324 23.847-12.546h-5.82e-4z",
    fill: "#FBBD07"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbarg);
export default __webpack_public_path__ + "static/media/bitbarg.96400aa4d35eaac713bbee7702b17fba.svg";
export { ForwardRef as ReactComponent };